import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faPencil } from '@fortawesome/pro-light-svg-icons';
import Button from 'components/UI/V3/Button/Button';
import { Switch } from 'components/UI/V3/Forms/Switch';
import styles from './RuleCard.module.scss';

interface RuleCardProps {
    icon: IconDefinition;
    title: string;
    description: string;
    checked: boolean;
    disabled?: boolean;
    onToggle: () => void;
    onEdit: () => void;
}

export const RuleCard = ({ icon, title, description, checked, disabled, onToggle, onEdit }: RuleCardProps) => (
    <article className={styles.ruleCard}>
        <div className={styles.ruleContent}>
            <span className={styles.ruleIcon}>
                <FontAwesomeIcon icon={icon} />
            </span>
            <div>
                <h3 className={styles.ruleTitle}>{title}</h3>
                <p className={styles.ruleDescription}>{description}</p>
            </div>
        </div>
        <div className={styles.ruleActions}>
            <Switch
                checked={checked}
                disabled={disabled}
                aria-label={`${title} loyalty earning rule`}
                className={styles.switchControl}
                onChange={onToggle}
            />
            <Button
                label="Edit"
                leftIcon={faPencil}
                variant="text-green"
                size="inline"
                className={styles.editButton}
                disabled={!checked}
                onClick={onEdit}
            />
        </div>
    </article>
);
